// extracted by mini-css-extract-plugin
export default {"topBarLabels":"style_topBarLabels__QiK7q","labelWrap":"style_labelWrap__XzgdS","amount":"style_amount__2y9VC","symbol":"style_symbol__8sYoq"};